import React, { useState } from "react";
import useDeviceType from "../../../custom-hooks/DeviceType";
import Button from "../button/Button";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import EventEHRConfirmationDialog from "../confimation-dialog/EventEHRConfirmationDialog";

interface EventEHRCareVisitFlowButtonsProps {
  isCancelButtonPresent?: boolean;
  isSaveASDraftButtonPresent?: boolean;
  isTransferButtonPresent?: boolean;
  isDischargeButtonPresent?: boolean;
  isFileIntervalNotePresent?: boolean;
  handleCancelButtonClickEvent: () => void;
  handleSaveAsDraftButtonClickEvent: () => void;
  handleTransferButtonClickEvent?: () => void;
  handleFileIntervalNoteButtonClickEvent?: () => void;
  handleProceedToDischargeButtonClickEvent: () => void;
}

const EventEHRCareVisitFlowButtons = ({
  isCancelButtonPresent = true,
  isSaveASDraftButtonPresent = true,
  isTransferButtonPresent = true,
  isDischargeButtonPresent = true,
  isFileIntervalNotePresent = false,
  handleCancelButtonClickEvent,
  handleSaveAsDraftButtonClickEvent,
  handleProceedToDischargeButtonClickEvent,
  handleTransferButtonClickEvent,
  handleFileIntervalNoteButtonClickEvent,
}: EventEHRCareVisitFlowButtonsProps) => {
  const deviceType = useDeviceType();

  //Cancel Button State
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const handleDialogOpen = () => {
    setIsCancelDialogOpen(true);
  };
  const handleCancelDialogClose = (action: string) => {
    if (action === "close") {
      setIsCancelDialogOpen(false);
    } else if (action === "submit") {
      handleCancelButtonClickEvent(); // Call the original cancel handler
      setIsCancelDialogOpen(false);
    }
  };

  return (
    <div
      className={`flex ${deviceType === "mobile" ? "justify-center gap-2" : "justify-end"} float-end gap-4 whitespace-nowrap`}
    >
      {isCancelButtonPresent && (
        <Button
          label={TEXT_CONSTANTS?.CANCEL}
          variant="outlined"
          onClickCb={() => {
            handleDialogOpen();
          }}
          style={{
            paddingTop: "6px",
            paddingBottom: "6px",
            backgroundColor: "white",
            border: "none",
            color: "#393939",
          }}
        ></Button>
      )}
      {isSaveASDraftButtonPresent && (
        <Button
          label={TEXT_CONSTANTS?.SAVE_AS_DRAFT}
          variant="outlined"
          onClickCb={() => {
            handleSaveAsDraftButtonClickEvent();
          }}
          style={{
            paddingTop: "6px",
            paddingBottom: "6px",
            backgroundColor: "white",
            border: "none",
            color: "#393939",
          }}
        ></Button>
      )}
      {isTransferButtonPresent && (
        <Button
          variant={"contained"}
          style={{
            background: "#E4F3FF",
            color: "#005596",
            padding: "7px 16px",
          }}
          onClickCb={() => {
            handleTransferButtonClickEvent && handleTransferButtonClickEvent();
          }}
          label="Transfer"
        />
      )}
      {isFileIntervalNotePresent && (
        <Button
          label="File Interval Note"
          variant="contained"
          onClickCb={() => {
            handleFileIntervalNoteButtonClickEvent &&
              handleFileIntervalNoteButtonClickEvent();
          }}
          style={{
            background: "#E4F3FF",
            color: "#005596",
            paddingTop: "6px",
            paddingBottom: "6px",
            minWidth: "155px",
          }}
        />
      )}
      {isDischargeButtonPresent && (
        <Button
          label={TEXT_CONSTANTS?.PROCEED_TO_DISCHARGE}
          variant="contained"
          onClickCb={() => {
            handleProceedToDischargeButtonClickEvent();
          }}
          style={{
            paddingTop: "6px",
            paddingBottom: "6px",
            minWidth: "155px",
          }}
        ></Button>
      )}
      {/* Confirmation Dialog Re-Used For Cancel Button*/}
      <EventEHRConfirmationDialog
        open={isCancelDialogOpen}
        alertTitle="Confirm"
        alertDescription="Are you sure you want to cancel this visit note?"
        cancelButtonTitle="No"
        submitButtonTitle="Yes"
        handleClose={handleCancelDialogClose}
      />
    </div>
  );
};

export default EventEHRCareVisitFlowButtons;
